module.exports = __webpack_public_path__ + "static/media/search.b04ecd85.svg";